<template>
  <div>
    <!-- Loading / Error State -->
    <div v-if="isLoading" class="flex justify-center items-center py-8">
      <div class="text-blueGray-500">데이터를 불러오는 중...</div>
    </div>
    <div v-if="error" class="flex justify-center items-center py-8">
      <div class="text-red-500">{{ error }}</div>
    </div>

    <!-- 3-Column Layout -->
    <div class="relative pb-1 pt-5">
      <div class="px-4 md:px-10 mx-auto w-full">
        <div class="flex flex-wrap">
          <!-- Column 1: Card Stats (3x2) -->
          <div class="w-full xl:w-4/12 px-4">
            <div class="relative flex flex-wrap" style="height: 494px;">
              <!-- Row 1 -->
              <div class="w-full lg:w-6/12 px-2">
                <card-stats
                  statSubtitle="언론"
                  :statTitle="totalStats?.press_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.press_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-alpha-n-box"
                  statIconBgColor="#03C75A"
                />
              </div>
              <div class="w-full lg:w-6/12 px-2 ">
                <card-stats
                  statSubtitle="블로그"
                  :statTitle="totalStats?.blog_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.blog_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-alpha-n-box"
                  statIconBgColor="#03C75A"
                />
              </div>
              <!-- Row 2 -->
              <div class="w-full lg:w-6/12 px-2 ">
                <card-stats
                  statSubtitle="지식인"
                  :statTitle="totalStats?.kin_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.kin_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-alpha-n-box"
                  statIconBgColor="#03C75A"
                />
              </div>
              <div class="w-full lg:w-6/12 px-2 ">
                <card-stats
                  statSubtitle="카페"
                  :statTitle="totalStats?.cafe_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.cafe_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-alpha-n-box"
                  statIconBgColor="#03C75A"
                />
              </div>
              <!-- Row 3 -->
              <div class="w-full lg:w-6/12 px-2 ">
                <card-stats
                  statSubtitle="커뮤니티"
                  :statTitle="totalStats?.community_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.community_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-alpha-c-box"
                  statIconColor="bg-violet-600"
                />
              </div>
              <div class="w-full lg:w-6/12 px-2 ">
                <card-stats
                  statSubtitle="유튜브"
                  :statTitle="totalStats?.youtube_count?.toLocaleString() || '0'"
                  statArrow="up"
                  :statPercent="todayStats?.youtube_count?.toLocaleString() || '0'"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Today"
                  statIconName="mdi mdi-youtube"
                  statIconBgColor="#FF0000"
                />
              </div>
            </div>
          </div>  

          <!-- Column 2: Pie Chart -->
          <div class="w-full xl:w-4/12 px-4">
            <card-pie-chart v-if="totalStats" :chartData="totalStats" />
            <div v-else class="bg-white p-4 rounded shadow">데이터가 없습니다.</div>
          </div>

          <!-- Column 3: Today Stats -->
          <div class="w-full xl:w-4/12 px-4">
            <card-today-stats v-if="todayStats" :todayData="todayStats" />
            <div v-else class="bg-white p-4 rounded shadow">데이터가 없습니다.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Project Stats Section -->
    <div class="px-4 md:px-10 mx-auto w-full" style="clear: both;">
      <div class="flex flex-wrap mt-12">
        <div class="w-full px-4 mb-6">
          <card-project-table :projectStats="projectStats" @project-selected="handleProjectSelected" />
        </div>
      </div>

      <div class="flex flex-wrap">
        <div class="w-full xl:w-8/12 px-4 mb-6">
          <card-project-dtl-table :projectDailyStats="projectDailyStats" />
        </div>
        <div class="w-full xl:w-4/12 px-4 mb-6">
          <card-project-daily-chart :projectDailyStats="projectDailyStats" />
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CardLineChart from "@/components/Cards/CardLineChart.vue";
import CardBarChart from "@/components/Cards/CardBarChart.vue";
import CardProjectTable from "@/components/Cards/CardProjectTable.vue";
import CardProjectDtlTable from "@/components/Cards/CardProjectDtlTable.vue";
import CardProjectDailyChart from "@/components/Cards/CardProjectDailyChart.vue";
import CardSocialTraffic from "@/components/Cards/CardSocialTraffic.vue";
import CardStats from "@/components/Cards/CardStats.vue";
import CardPieChart from "@/components/Cards/CardPieChart.vue";
import CardTodayStats from "@/components/Cards/CardTodayStats.vue";

export default {
  name: "dashboard-page",
  components: {
    CardLineChart,
    CardBarChart,
    CardProjectTable,
    CardProjectDtlTable,
    CardProjectDailyChart,
    CardSocialTraffic,
    CardStats,
    CardPieChart,
    CardTodayStats,
  },
  computed: {
    ...mapGetters('crawlingStats', [
      'projectStats',
      'totalStats',
      'todayStats',
      'projectDailyStats',
      'isLoading',
      'error',
    ]),
  },
  methods: {
    ...mapActions('crawlingStats', [
      'fetchProjectStats',
      'fetchTotalStats',
      'fetchTodayStats',
      'fetchAllStats',
      'fetchProjectDailyStats',
    ]),
    handleProjectSelected(project) {
      console.log('Selected project for daily collection status:', project);
      if (project && project.project_id) {
        this.fetchProjectDailyStats(project.project_id);
      }
    },
  },
  mounted() {
    // 화면이 열릴 때 모든 통계 데이터 조회
    this.fetchAllStats();
  },
  watch: {
    totalStats(newVal) {
      console.log('totalStats updated:', newVal);
    },
    todayStats(newVal) {
      console.log('todayStats updated:', newVal);
    },
    projectStats(newVal) {
      console.log('projectStats updated:', newVal);
    }
  },
};
</script>
